export default "__VITE_ASSET__DHNCEROH__"